(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["olz-instagram-shop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__olzIgs) return; window.__olzIgs = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-olz-igs]');
      if (a && window.clarity) try { window.clarity('event', 'ig_shop_click'); } catch (x) {}
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
